import { render, staticRenderFns } from "./defined-info-modal.vue?vue&type=template&id=2fc340fc&scoped=true"
import script from "./defined-info-modal.vue?vue&type=script&lang=js"
export * from "./defined-info-modal.vue?vue&type=script&lang=js"
import style0 from "./defined-info-modal.vue?vue&type=style&index=0&id=2fc340fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc340fc",
  null
  
)

export default component.exports